import Vue from "vue";
import Router from "vue-router";
import Home from "./layout/Home.vue";
import App from "./App.vue";
import store from "./store";

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "",
    name: "首页",
    redirect: "/index",
    component: Home,
    children: [
      {
        path: "/index",
        component: () => import("@/views/index"),
        name: "系统首页",
        meta: {
          icon: "el-icon-s-home",
          title: "系统首页",
        },
      },
      // {
      //   path: "/officialNews",
      //   component: () => import("./views/officialNews/officialNews"),
      //   hidden: true,
      //   name: "官方消息",
      //   meta: {
      //     title: '官方消息',
      //     icon: 'el-icon-s-comment'
      //   }
      // },
    ],
  },

  {
    path: "/login",
    hidden: true,
    component: () => import("./views/login"),
  },

  {
    path: "",
    name: "网吧管理",
    redirect: "/netbarmanage",
    component: Home,
    children: [
      {
        path: "netbarmanage",
        component: () => import("./views/netbarmanage/netbarmanage"),
        name: "网吧管理",
        meta: {
          title: "网吧管理",
          icon: "el-icon-s-platform",
        },
      },
      {
        path: "/newInternetBar",
        component: () => import("./views/netbarmanage/newInternetBar"),
        hidden: true,
        name: "新建网吧",
        // meta: {
        //   title: '新建网吧',
        //   icon: 'el-icon-s-comment'
        // }
      },
    ],
  },
  {
    path: '',
    name: '扫码管理',
    redirect: '/order',
    component: Home,
    meta: {
      title: '扫码管理',
      icon: 'el-icon-receiving'
    },
    children: [{
        path: '/order',
        component: () => import('./views/orderDetail/orderDetail'),
        name: '扫码订单',
        meta: {
          title: '扫码订单',
          icon: 'el-icon-s-order'
        }
      },
      {
        path: '/agentAccountMumber',
        component: () => import('./views/agentManagement/agentAccountMumber'),
        name: '扫码分成',//原叫扫码流水
        meta: {
          title: '扫码分成',
          icon: 'el-icon-c-scale-to-original'
        },
      },
      // {
      //   path: '/agentLiveDay',
      //   component: () => import('./views/agentManagement/agentLiveDay'),
      //   name: '扫码日活',//原叫扫码流水
      //   meta: {
      //     title: '扫码日活',
      //     icon: 'el-icon-s-data'
      //   },
      // },
      // {
      //   path: '/divideInto',
      //   component: () => import('./views/divideInto/divideInto'),
      //   name: '分成管理',
      //   meta: {
      //     title: '分成管理',
      //     icon: 'el-icon-s-order'
      //   }
      // }
    ]
  },
  {
    path: "",
    name: "订单管理",
    redirect: "/monthlyflow",
    component: Home,
    children: [
      {
        path: "/monthlyflow",
        component: () => import("./views/netbarmanage/channelFlow"),
        name: "订单详情", //原叫包月流水
        meta: {
          title: "订单详情",
          icon: "el-icon-s-order",
        },
      },
      // {
      //   path: "/barAccountfc",
      //   component: () => import("./views/netbarmanage/barAccountfc"),
      //   name: "订单分成",
      //   meta: {
      //     title: "订单分成",
      //     icon: "el-icon-c-scale-to-original",
      //   },
      // },
    ],
  },

  // {
  //   path: '',
  //   name: '订单管理',
  //   redirect: '/order',
  //   component: Home,
  //   children: [{
  //     path: '/order',
  //     component: () => import('./views/orderDetail/orderDetail'),
  //     name: '订单管理',
  //     meta: {
  //       title: '订单管理',
  //       icon: 'el-icon-s-order'
  //     }
  //   }]
  // },

  // {
  //   path: '',
  //   name: '分成管理',
  //   redirect: '/divideInto',
  //   component: Home,
  //   children: [{
  //     path: '/divideInto',
  //     component: () => import('./views/divideInto/divideInto'),
  //     name: '分成管理',
  //     meta: {
  //       title: '分成管理',
  //       icon: 'el-icon-eleme'
  //     }
  //   }]
  // },

  // {
  //   path: '/fencen',
  //   component: Home,
  //   name: '分成管理',
  //   alwaysShow: true,
  //   meta: {
  //     title: "分成管理",
  //     icon: "fa fa-user-o"
  //   },
  //   children : [
  //     {
  //       path: 'divideInto',
  //       hidden: false,
  //       component: () => import('./views/divideInto/divideInto'),
  //       name: '下级分成管理',
  //       meta: {
  //         title: '下级分成管理',
  //         icon: 'fa fa-users'
  //       },
  //     },
  // {
  //   path: 'myDivideInto',
  //   hidden: false,
  //   component: () => import('./views/divideInto/myDivideInto'),
  //   name: '分成管理',
  //   meta: {
  //     title: '分成管理',
  //     icon: 'fa fa-users'
  //   },
  // },
  //   ]
  // },

  // {
  //   path:'',
  //   name:'分成试试管理',
  //   redirect:'/divideInto',
  //   component: Home,
  //   children:[
  //     {
  //       path:'/divideInto',
  //       component: () => import('./views/divideInto/divideInto'),
  //       name:'分成管理',
  //       meta:{
  //         title: '分成管理',
  //         icon: 'fa fa-users'
  //       }
  //     }
  //   ]
  // },

  // {
  //   path:'',
  //   name:'提现管理',
  //   redirect:'/withdrawalManagement',
  //   component: Home,
  //   children:[
  //     {
  //       path:'/withdrawalManagement',
  //       component: () => import('./views/withdrawalManagement/withdrawalManagement'),
  //       name:'提现管理',
  //       meta:{
  //         title: '提现管理',
  //         icon: 'fa fa-users'
  //       }
  //     }
  //   ]
  // },

  {
    path: "",
    name: "渠道包下载",
    redirect: "/channelPacket",
    component: Home,
    meta: {
      title: "渠道包下载",
      icon: "el-icon-download",
    },
    children: [
      {
        path: "/channelPacket",
        component: () => import("@/views/channelPacket"),
        name: "扫码部署下载",
        meta: {
          title: "扫码部署下载",
          icon: "el-icon-download",
        },
      },
      {
        path: "/by_channelPacket",
        component: () => import("@/views/by_channelPacket"),
        name: "包月安装下载",
        meta: {
          title: "包月安装下载",
          icon: "el-icon-download",
        },
      },
    ],
  },
  {
    path: '',
    name: '官方消息',
    redirect: '/officialNews',
    component: Home,
    children: [{
      path: '/officialNews',
      component: () => import('./views/officialNews/officialNews'),
      name: '官方消息',
      meta: {
        title: '官方消息',
        icon: 'el-icon-s-comment'
      }
    }]
  },

  // {
  //   path: '',
  //   name: '终端数量',
  //   redirect: '/terminalStatistics',
  //   component: Home,
  //   children: [{
  //     path: '/terminalStatistics',
  //     component: () => import('./views/terminalStatistics/terminalStatistics'),
  //     name: '终端数量',
  //     meta: {
  //       title: '终端数量',
  //       icon: 'el-icon-bank-card'
  //     }
  //   }]
  // },

  {
    path: "",
    component: Home,
    name: "提现管理",
    redirect: "withdrawalManagement",
    // alwaysShow: true,
    meta: {
      title: "提现管理",
      icon: "el-icon-s-finance",
    },
    children: [
      {
        path: "withdrawalManagement",
        hidden: false,
        component: () =>
          import("./views/withdrawalManagement/withdrawalManagement"),
        name: "提现申请列表",
        meta: {
          title: "提现申请列表",
          icon: "el-icon-s-finance",
        },
      },
      // {
      //   path: "myDivideInto",
      //   hidden: false,
      //   component: () => import("./views/divideInto/myDivideInto"),
      //   name: "分成管理",
      //   meta: {
      //     title: "分成管理",
      //     icon: "el-icon-s-finance",
      //   },
      // },
    ],
  },

  // {
  //   path: '/account',
  //   component: Home,
  //   name: '账号管理',
  //   alwaysShow: true,
  //   meta: {
  //     title: "账号管理",
  //     icon: "fa fa-user-o"
  //   },
  //   children : [
  //     {
  //       path: 'accountManage',
  //       hidden: false,
  //       component: () => import('./views/accountManage/account1'),
  //       name: '账号管理',
  //       meta: {
  //         title: '账号管理',
  //         icon: 'fa fa-users'
  //       },
  //     },
  //     {
  //       path: 'adminDes',
  //       hidden: true,
  //       component: () => import('./views/accountManage/adminDes'),
  //       name: '账号详情',
  //       meta: {
  //         title: '账号详情',
  //         icon: 'fa fa-users'
  //       },
  //     },
  //     {
  //       path: 'barDes',
  //       hidden: true,
  //       component: () => import('./views/accountManage/barDes'),
  //       name: '二级详情',
  //       meta: {
  //         title: '二级详情',
  //         icon: 'fa fa-users'
  //       },
  //     }

  //   ]
  // },

  // {
  //   path: '/fencen',
  //   component: Home,
  //   name: '分成管理',
  //   alwaysShow: true,
  //   meta: {
  //     title: "分成管理",
  //     icon: "fa fa-user-o"
  //   },
  //   children : [
  //     {
  //       path: 'dailiFencen',
  //       hidden: false,
  //       component: () => import('./views/fencengManage/adminFen'),
  //       name: '分成管理',
  //       meta: {
  //         title: '分成管理',
  //         icon: 'fa fa-users'
  //       },
  //     },
  //     {
  //       path: 'barFencen',
  //       hidden: true,
  //       component: () => import('./views/fencengManage/barFencen'),
  //       name: '网吧分成',
  //       meta: {
  //         title: '网吧分成',
  //         icon: 'fa fa-users'
  //       },
  //     },
  //   ]
  // },

  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];

//子管理员权限
export const subAdminRouterMap = [
  // 代理商管理
  {
    path: "",
    component: Home,
    name: "代理商管理",
    redirect: "/agentManagements",
    //alwaysShow: true,
    children: [
      {
        path: "/agentManagements",
        hidden: false,
        component: () => import("./views/agentManagement/agentManagements"),
        name: "代理商管理",
        meta: {
          title: "代理商管理",
          icon: "el-icon-s-check",
        },
      },
    ],
  },
  {
    path: "",
    name: "子管理员",
    redirect: "/WithdrawalAuditForm",
    component: Home,
    alwaysShow: true,
    meta: {
      title: "子管理员",
      icon: "el-icon-s-custom",
    },
    children: [
      {
        path: "/registrationSurface",
        component: () => import("./views/netbarmanage/registrationSurface"),
        name: "账号注册审核表",
        meta: {
          title: "账号注册审核表",
          icon: "el-icon-document-checked",
        },
      },
      // {
      //   path: 'qudaobao',
      //   component: () => import('./views/systemSetting/qudaobao.vue'),
      //   name: '版本上传',
      //   meta: {
      //     title: '版本上传',
      //     icon: 'fa fa-folder-o'
      //   }
      // },
      {
        path: "/OperationLog",
        component: () => import("./views/netbarmanage/OperationLog"),
        name: "操作日志",
        meta: {
          title: "操作日志",
          icon: "el-icon-receiving",
        },
      },
    ],
  },
];
//这部分隐藏？
export const adminRouterMap = [
  // 代理商管理
  {
    path: "",
    component: Home,
    name: "代理商管理",
    redirect: "/agentManagements",
    //alwaysShow: true,
    children: [
      {
        path: "/agentManagements",
        hidden: false,
        component: () => import("./views/agentManagement/agentManagements"),
        name: "代理商管理",
        meta: {
          title: "代理商管理",
          icon: "el-icon-s-check",
        },
      },
    ],
  },
  {
    path: "",
    name: "管理员",
    redirect: "/WithdrawalAuditForm",
    component: Home,
    alwaysShow: true,
    meta: {
      title: "管理员",
      icon: "el-icon-s-custom",
    },
    children: [
      {
        path: "/WithdrawalAuditForm",
        component: () =>
          import("./views/WithdrawalAuditForm/WithdrawalAuditForm"),
        name: "提现审核表",
        meta: {
          title: "提现审核表",
          icon: "el-icon-s-finance",
        },
      },
      {
        path: "/refundOrder",
        component: () => import("./views/netbarmanage/refundOrder"),
        name: "时长扣减", //原叫包月流水
        meta: {
          title: "时长扣减订单",
          icon: "el-icon-s-order",
        },
      },
      {
        path: "/registrationSurface",
        component: () => import("./views/netbarmanage/registrationSurface"),
        name: "账号注册审核表",
        meta: {
          title: "账号注册审核表",
          icon: "el-icon-document-checked",
        },
      },
      // {
      //   path: 'qudaobao',
      //   component: () => import('./views/systemSetting/qudaobao.vue'),
      //   name: '版本上传',
      //   meta: {
      //     title: '版本上传',
      //     icon: 'fa fa-folder-o'
      //   }
      // },
      {
        path: "/OperationLog",
        component: () => import("./views/netbarmanage/OperationLog"),
        name: "操作日志",
        meta: {
          title: "操作日志",
          icon: "el-icon-receiving",
        },
      },
      {
        path: '/regionAddManager',
        component: () => import('./views/netbarmanage/regionAddManager'),
        name: '新增子管理员',
        meta: {
          title: '新增子管理员',
          icon: 'el-icon-document'
        }
      },
      {
        path: "/announcement",
        component: () => import("./views/netbarmanage/announcement"),
        name: "发布公告",
        meta: {
          title: "发布公告",
          icon: "el-icon-s-comment",
        },
      },
      {
        path: "/netbarmanageTY",
        component: () => import("./views/netbarmanage/netbarmanageTY"),
        name: "腾游网吧删除",
        meta: {
          title: "腾游网吧删除",
          icon: "el-icon-s-comment",
        },
      },
      {
        path: "/qrcodegamepriceconfig",
        component: () => import("./views/netbarmanage/qrcodegamepriceconfig"),
        name: "扫码版价格配置",
        meta: {
          title: "扫码版价格配置",
          icon: "el-icon-s-comment",
        },
      },
    ],
  },
  /*{
    path: '/system',
    component: Home,
    alwaysShow: true,
    name: '系统设置',
    meta: {
      title: '系统设置',
      icon: 'fa fa-cog'
    },
    children: [{
      path: 'goodSet',
      hidden: false,
      component: () => import('./views/systemSetting/goodSet.vue'),
      name: '扫码商品设置',
      meta: {
        title: '扫码商品设置',
        icon: 'fa fa-folder-o'
      }
    }]
  }*/
];
export const asyncRouterMap = [];
const routes = [...constantRouterMap, ...asyncRouterMap, ...adminRouterMap, ...subAdminRouterMap];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});
export default router;
